/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Intake_Waist_WhyInputs */

const en_us2_body_assessment_intake_waist_why = /** @type {(inputs: Body_Assessment_Intake_Waist_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is the biggest accuracy gain available without a lab test.`)
};

const pt_br2_body_assessment_intake_waist_why = /** @type {(inputs: Body_Assessment_Intake_Waist_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É o maior ganho de precisão que existe sem fazer um exame.`)
};

const es_419_body_assessment_intake_waist_why = /** @type {(inputs: Body_Assessment_Intake_Waist_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es la mayor ganancia de precisión posible sin un estudio de laboratorio.`)
};

const pt_pt2_body_assessment_intake_waist_why = /** @type {(inputs: Body_Assessment_Intake_Waist_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É o maior ganho de precisão possível sem fazer um exame.`)
};

const fr_fr2_body_assessment_intake_waist_why = /** @type {(inputs: Body_Assessment_Intake_Waist_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est le plus gros gain de précision possible sans examen.`)
};

const de_de2_body_assessment_intake_waist_why = /** @type {(inputs: Body_Assessment_Intake_Waist_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ist der größte Genauigkeitsgewinn, den es ohne Labortest gibt.`)
};

const it_it2_body_assessment_intake_waist_why = /** @type {(inputs: Body_Assessment_Intake_Waist_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È il maggior guadagno di precisione possibile senza un esame.`)
};

/**
* | output |
* | --- |
* | "It is the biggest accuracy gain available without a lab test." |
*
* @param {Body_Assessment_Intake_Waist_WhyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_intake_waist_why = /** @type {((inputs?: Body_Assessment_Intake_Waist_WhyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Intake_Waist_WhyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_intake_waist_why(inputs)
	if (locale === "es-419") return es_419_body_assessment_intake_waist_why(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_intake_waist_why(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_intake_waist_why(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_intake_waist_why(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_intake_waist_why(inputs)
	return en_us2_body_assessment_intake_waist_why(inputs)
});
export { body_assessment_intake_waist_why as "body-assessment.intake_waist_why" }